import {OEAsset, useClient, useDictionary, useItem} from '@adamlip/okeoke.client'
import {Button, Checkbox, Divider, Drawer, DrawerBody, DrawerContent, Textarea} from '@heroui/react'
import {useContext, useEffect, useRef, useState} from 'react'
import toast from 'react-hot-toast'
import {Element} from 'react-scroll'
import LoginModal from '../../../views/Login'
import ModifierGroupSelector from './ModifierGroupSelector'
import SizeSelector from './SizeSelector'
import {UserContext} from 'contexts/UserContext'
import useBasket from 'hooks/useBasket'
import {AppParamsContext} from 'contexts/AppParamsContext'
import MenuSelectModal from 'components/Modals/MenuSelectModal'
import BarSoftButton from 'components/_NewComponents/BarSoftButton'
import UpsaleItem from 'components/_OrderElements/UpsaleItem'
import Icon from 'assets/icons'
import {BarSoftDrawer, BarSoftDrawerContent, BarSoftDrawerTitle} from 'components/_NewComponents/Drawer'
import NumberFlow from '@number-flow/react'
import {Check, Minus, Plus, ShoppingCart} from 'lucide-react'
import {AnimatePresence, motion} from 'framer-motion'
import SendVibration from 'utils/Helpers-v1/SendVibration'
import ImageFocusedLayout from 'components/Modals/OrderItemModalV3/ImageFocusedLayout'
function OrderItemModalV3({isOpen, safeMode, setIsOpen, itemUUID, setLoginModalOpened, readOnly, sizeUUID, menuItemParams, couponItem, onCouponItemSelect, onCloseCustom}) {
	const {getName} = useClient()
	const {appParams, desktopView} = useContext(AppParamsContext)
	const {getValue} = useDictionary()
	const {assembledItem, setSize, setCount, setModifierCount, setTakeAway, setNotes, getUpsales} = useItem(itemUUID, sizeUUID)
	const {addItem} = useBasket()
	const touchRef = useRef(null)

	const {userLoggedIn} = useContext(UserContext)

	const [itemNotes, setItemNotes] = useState('')
	const [allergens, setAllergens] = useState([])
	const [upsaleItems, setUpsaleItems] = useState([])
	const [tryedToAdd, setTryedToAdd] = useState(false)
	const [showMore, setShowMore] = useState(false)
	const [loginModal, setLoginModal] = useState(false)
	const [menuSelectIsOpen, setMenuSelectIsOpen] = useState(false)
	const [showMenuOptions, setShowMenuOptions] = useState(false)
	const [selectedMenuSize, setSelectedMenuSize] = useState(null)
	const [buttonText, setButtonText] = useState('')
	const [noMenuSelected, setNoMenuSelected] = useState(false)
	const {itemName, itemDescription, addToBasketButton, changeCountButton} = appParams?.items?.itemModalStyle || {}
	const [showLoginDescModal, setShowLoginDescModal] = useState(false)
	const [userSelectedMenuOption, setUserSelectedMenuOption] = useState(false)
	const [isAdded, setIsAdded] = useState(false)
	const addItemToBasket = () => {
		if (readOnly) return null
		if (userLoggedIn) {
			if (assembledItem.valid) {
				if (menuItemParams && typeof menuItemParams?.onAdd === 'function') {
					menuItemParams?.onAdd(assembledItem)
					setTryedToAdd(false)
					setTimeout(() => {
						setIsOpen(false)
					}, 1000)
				} else {
					if (assembledItem?.count > 0) {
						let response = addItem(assembledItem)
						if (response != null) {
							setTryedToAdd(false)
							SendVibration('success')

							setTimeout(() => {
								setIsOpen(false)
							}, 1000)
						} else {
							console.log(response)
							toast.error(getValue('app_v2_toast_itemFailed'))
						}
					}
				}
			} else {
				setTryedToAdd(true)
				toast.error(getValue('app_v2_toast_itemFailed'))
			}
		} else {
			setShowLoginDescModal(true)
			if (typeof setLoginModalOpened === 'function') {
				setLoginModalOpened(true)
			}
		}
	}
	const handleAddToCart = async () => {
		if (!isAdded) {
			if (userLoggedIn) {
				setIsAdded(true)
			}
			addItemToBasket()

			setTimeout(() => {
				setTimeout(() => {
					setIsAdded(false)
				}, 500)
			}, 2000 + 300)
		}
	}
	const changeCount = (count) => {
		if (count == null) return
		if (menuItemParams?.maxSelect) {
			if (count > menuItemParams?.maxSelect) {
				if (typeof setCount === 'function') {
					SendVibration('light')

					setCount(menuItemParams?.maxSelect)
				}
			} else {
				if (typeof setCount === 'function') {
					SendVibration('light')

					setCount(count)
				}
			}
		} else {
			if (typeof setCount === 'function') {
				SendVibration('light')

				setCount(count)
			}
		}
	}

	const handleChangeNotes = (e) => setItemNotes(e.target.value)

	const handleBlurNotes = () => setNotes(itemNotes?.slice(0, 100))

	const displayDescription = (description) => {
		const descriptionLength = description?.length
		if (descriptionLength > 250) {
			return (
				<div className={`px-4 text-xs opacity-60 w-full  ${appParams?.styles?.fonts?.capitalize ? 'font-bold !uppercase' : ''} ${renderExtraClass(itemDescription, true)}`}>
					{showMore ? description : description.slice(0, 120) + '...'}
					<span className='ml-2 text-primary font-bold' onClick={() => setShowMore(!showMore)}>
						{showMore ? getValue('app_v2_showLess') : getValue('app_v2_showMore')}
					</span>
				</div>
			)
		} else {
			return <div className={`px-4 text-xs opacity-60  text-clip w-full ${renderExtraClass(itemDescription, true)}}`}>{description}</div>
		}
	}

	const renderExtraClass = (type, isDescription) => {
		let extraClass = ''
		extraClass += ` ${type?.fontSize || (isDescription ? 'text-xs' : 'text-sm')} ${type?.fontWeight || (isDescription ? 'font-light' : 'font-bold')}`
		if (type?.uppercase) {
			extraClass += ` !uppercase `
		}
		if (type?.fontColor) {
			extraClass += ` text-[${type?.fontColor}]`
		}

		return extraClass
	}

	const handleItemSelect = (assembledItem) => {
		if (typeof onCouponItemSelect === 'function') {
			onCouponItemSelect(assembledItem)
		}
		setIsOpen(false)
	}

	useEffect(() => {
		if (couponItem == null) {
			if (menuItemParams == null && !noMenuSelected && isOpen) {
				if (isOpen && assembledItem?.sizes && assembledItem) {
					let normalSizeCount = 0
					let menuSizeCount = 0
					for (let size of assembledItem?.sizes) {
						if (size?.attributes?.menuSize) {
							menuSizeCount += 1
						} else {
							normalSizeCount += 1
						}
					}
					if (menuSizeCount > 0) {
						setMenuSelectIsOpen(true)
					}
					if (normalSizeCount < 1) {
						console.log(normalSizeCount, assembledItem?.sizes)
						// setIsOpen(false);
					}
				}
			}
		}
		//eslint-disable-next-line
	}, [isOpen, assembledItem, couponItem])

	useEffect(() => {
		let text = getValue('app_v2_addToBasket')

		if (readOnly) {
			text = getValue('app_v2_item_price')
		} else {
			if (menuItemParams?.selected) {
				if (assembledItem?.count > 0) {
					text = getValue('app_v2_refreshInMenu')
				} else {
					text = getValue('app_v2_removeFromMenu')
				}
			} else {
				if (assembledItem?.count > 0) {
					text = getValue('app_v2_addToMenu')
				} else {
					text = getValue('app_v2_close_menu')
				}
			}
		}

		setButtonText(text)
		//eslint-disable-next-line
	}, [assembledItem, menuItemParams, readOnly])

	useEffect(() => {
		if (isOpen) {
			if (assembledItem == null) return
			if (assembledItem?.count == null || assembledItem?.count < 1) {
				if (typeof setCount === 'function') {
					setCount(1)
				}
			}
		} else {
			setNoMenuSelected(false)
		}
		//eslint-disable-next-line
	}, [isOpen])

	useEffect(() => {
		if (!menuSelectIsOpen) {
			setShowMenuOptions(false)
			setSelectedMenuSize(null)
		}
	}, [menuSelectIsOpen])

	useEffect(() => {
		if (isOpen && assembledItem != null) {
			let items = getUpsales()
			if (Array.isArray(items)) setUpsaleItems(items)
		}
		// eslint-disable-next-line
	}, [isOpen, assembledItem])

	useEffect(() => {
		if (isOpen && assembledItem != null && typeof setCount === 'function' && (assembledItem?.count < 1 || assembledItem?.count == null) && menuItemParams == null) {
			setCount(1)
		}

		if (assembledItem != null) {
			let allergenArray = []
			for (let [key, value] of Object.entries(assembledItem.allergens || {})) {
				if (value != null && value > 0) allergenArray.push(key)
			}
			setAllergens(allergenArray)
		}
		// eslint-disable-next-line
	}, [isOpen, assembledItem])

	if (assembledItem == null) return null
	return (
		<>
			<LoginModal
				isOpen={loginModal}
				setIsOpen={setLoginModal}
				canGuestLogin={true}
				onSuccessLogin={() => {
					setLoginModal(false)
					setShowLoginDescModal(false)
					setIsOpen(true)
					setMenuSelectIsOpen(false)
					if (typeof setLoginModalOpened === 'function') {
						setLoginModalOpened(false)
					}
				}}
			/>

			{safeMode ? (
				<>
					<Drawer
						isOpen={isOpen}
						onOpenChange={(open) => {
							setIsOpen(!isOpen)
							setTimeout(() => {
								setShowLoginDescModal(false)
								setMenuSelectIsOpen(false)
								setIsAdded(false)
							}, 400)
							if (typeof onCloseCustom === 'function') {
								onCloseCustom()
							}
						}}
						aria-describedby='desc'>
						<DrawerContent>
							<DrawerBody className='px-0 pt-0 flex flex-col gap-0 overflow-hidden w-full z-50' aria-describedby='desc'>
								{(showLoginDescModal || (!userLoggedIn && menuSelectIsOpen)) && (
									<div className='flex flex-col gap-2 items-center justify-center w-full p-2 pt-8 pb-10 '>
										<div className='w-16 h-16'>
											<Icon name='login' className='fill-current' />
										</div>
										<h1 className='font-bold text-lg'>{getValue('app_v2_orderItem_loginRequired')}</h1>
										<p className='w-full text-center opacity-70 text-sm'>{getValue('app_v2_orderItem_loginRequired_desc')}</p>
										<BarSoftButton
											color='primary'
											onPress={() => {
												setLoginModal(true)
												setShowLoginDescModal(false)
												setIsOpen(false)
												if (typeof setLoginModalOpened === 'function') {
													setLoginModalOpened(true)
												}
											}}>
											{getValue('app_v2_orderItem_login')}
										</BarSoftButton>
										<BarSoftButton
											color='secondary'
											onPress={() => {
												setShowLoginDescModal(false)
												if (typeof setLoginModalOpened === 'function') {
													setLoginModalOpened(false)
												}
											}}>
											{getValue('app_v2_orderItem_close')}
										</BarSoftButton>
									</div>
								)}
								{!showLoginDescModal && menuSelectIsOpen && userLoggedIn && assembledItem !== null && (
									<MenuSelectModal
										isOpen={menuSelectIsOpen}
										setIsOpen={setMenuSelectIsOpen}
										setShowMenuOptions={setShowMenuOptions}
										showMenuOptions={showMenuOptions}
										sizes={assembledItem?.sizes}
										setSelectedMenuSize={setSelectedMenuSize}
										selectedMenuSize={selectedMenuSize}
										closeItemModal={() => {
											setIsOpen(false)
										}}
										setSize={setSize}
										addItem={addItem}
										setNoMenuSelected={setNoMenuSelected}
										userSelectedMenuOption={userSelectedMenuOption}
										setUserSelectedMenuOption={setUserSelectedMenuOption}
									/>
								)}
								{!showLoginDescModal && assembledItem !== null && !menuSelectIsOpen && (
									<>
										{appParams?.items?.modalLayout === 'imageFocued' ? (
											<ImageFocusedLayout
												assembledItem={assembledItem}
												itemName={itemName}
												itemDescription={itemDescription}
												allergens={allergens}
												menuItemParams={menuItemParams}
												sizeUUID={sizeUUID}
												readOnly={readOnly}
												upsaleItems={upsaleItems}
												couponItem={couponItem}
												onCouponItemSelect={onCouponItemSelect}
												onCloseCustom={onCloseCustom}
												displayDescription={displayDescription}
												setItemNotes={setItemNotes}
												setModifierCount={setModifierCount}
												setTryedToAdd={setTryedToAdd}
												setTakeAway={setTakeAway}
												setSize={setSize}
												setCount={setCount}
												setNotes={setNotes}
												setAllergens={setAllergens}
												setUpsaleItems={setUpsaleItems}
												setShowMore={setShowMore}
												setIsAdded={setIsAdded}
												setShowMenuOptions={setShowMenuOptions}
												setMenuSelectIsOpen={setMenuSelectIsOpen}
												setSelectedMenuSize={setSelectedMenuSize}
												setUserSelectedMenuOption={setUserSelectedMenuOption}
												setNoMenuSelected={setNoMenuSelected}
												setIsOpen={setIsOpen}
												tryedToAdd={tryedToAdd}
												itemNotes={itemNotes}
												handleChangeNotes={handleChangeNotes}
												handleBlurNotes={handleBlurNotes}
												setShowLoginDescModal={setShowLoginDescModal}
												handleAddToCart={handleAddToCart}
												buttonText={buttonText}
												isAdded={isAdded}
												changeCount={changeCount}
												handleItemSelect={handleItemSelect}
											/>
										) : (
											<>
												<div className='  w-full  overflow-x-hidden  !relative overflow-y-auto pb-2'>
													{assembledItem.availability.available === 0 && <div className='py-2 font-bold text-warning font-small text-center mb-1'>{getValue('app_v2_orderItem_notAvailable')}</div>}
													{(appParams?.items?.showImage || appParams?.items?.showImage === undefined) && appParams?.assets?.defaultItemImg != null && (
														<div className='overflow-hidden rounded-b-general' id='scrollContainer'>
															<div className={`${appParams?.styles?.items?.containItemModalImage ? 'bg-white' : ''}`}>
																<OEAsset
																	uuid={assembledItem.attributes.appImage}
																	addContainerClass='w-[500px] max-w-full h-[300px] max-h-[300px] overflow-hidden'
																	addClass={`w-full h-full overflow-hidden ${appParams?.styles?.items?.containItemModalImage ? 'img-contain object-contain' : 'object-cover'}`}
																	size='l'
																/>
															</div>
														</div>
													)}
													<div className='z-50 sticky top-0 pt-4 bg-background'>
														<div className='px-4 pt-1 pb-0 flex flex-row gap-1 bg-background items-center !relative z-50'>
															<div
																id='desc'
																className={`font-bold text-xl  ${appParams?.styles?.fonts?.capitalize ? 'font-extrabold uppercase' : ''} `}
																style={{
																	color: itemName?.fontColor || '',
																}}>
																{getName(assembledItem.name)}
															</div>
														</div>
													</div>
													<div
														className=''
														style={{
															color: itemDescription?.fontColor || '',
														}}>
														{displayDescription(getName(assembledItem.description))}
													</div>
													{menuItemParams == null && assembledItem?.depositPrice > 0 && (
														<div className='w-full text-left px-4 text-sm opacity-70 italic'>
															{getValue('app_v2_item_deposit')}
															{' ('}
															{assembledItem?.depositPrice}
															{' Ft)'}
														</div>
													)}
													<div className='w-full flex flex-wrap gap-2 flex-row px-2'>
														{allergens.map((alle, index) => (
															<div key={index} className='text-foreground'>
																<div className='w-6 h-6'>
																	<Icon name={alle} className='fill-current' secondClassName={'fill-background'} />
																</div>
															</div>
														))}
													</div>
													<div className='px-2'>
														{allergens.length > 0 && (
															<span className=' text-sm'>
																<span className='pl-1'>{getValue('app_v2_allergens')}: </span>
																{allergens.map((alle, index) => (
																	<span key={index} className='allergen'>
																		{getValue('app_v2_allergens_' + alle)}
																		{allergens.length !== index + 1 && ', '}
																	</span>
																))}
															</span>
														)}
														<div className=' mt-1'>
															{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('meat') && (
																<div className='w-6 h-6'>
																	<Icon name={'meat'} className='fill-current' secondClassName={'fill-background/0'} />
																</div>
															)}
															{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('lactoseFree') && (
																<div className='w-6 h-6'>
																	<Icon name={'milk'} className='fill-current' secondClassName={'fill-background/0'} />
																</div>
															)}
															{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('vegan') && (
																<div className='w-6 h-6'>
																	<Icon name={'vegan'} className='fill-current' secondClassName={'fill-background/0'} />
																</div>
															)}
															{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('glutenFree') && (
																<div className='w-6 h-6'>
																	<Icon name={'glutenFree'} className='fill-current' secondClassName={'fill-background/0'} />
																</div>
															)}
														</div>
													</div>
													{menuItemParams == null && sizeUUID == null && assembledItem?.sizes?.filter((size) => !size?.attributes?.menuSize).length > 1 && (
														<div className=' z-10 px-2'>
															<SizeSelector sizes={assembledItem.sizes?.filter((size) => !size?.attributes?.menuSize)} setSize={setSize} selectedSizeUUID={assembledItem.selectedSizeUUID} />
														</div>
													)}
													<div className='px-2 flex flex-col gap-2 w-full z-0 !relative '>
														{assembledItem.modifierGroups
															?.filter((group) => group?.availability?.visible === 1)
															.sort((a, b) => (a?.min > b?.min ? 1 : -1))
															.sort((a, b) => (a?.idx > b?.idx ? 1 : -1))
															.map((group, index) => {
																return (
																	<Element key={group.uuid} name={group.uuid}>
																		<ModifierGroupSelector key={group.uuid} firstInvalid={null} group={group} setModifierCount={setModifierCount} readOnly={readOnly} tryedToAdd={tryedToAdd} name={group?.uuid} />
																	</Element>
																)
															})}
														{!readOnly && !(appParams?.items?.takeAwayHidden === true) && (
															<div className='my-2 w-full'>
																<Checkbox isSelected={assembledItem.takeAway} onValueChange={() => setTakeAway(assembledItem.takeAway ? 0 : 1)}>
																	<div className='flex flex-row gap-2 items-center'>
																		<div className='w-6 h-6'>
																			<Icon name='takeAway' className='fill-current' />
																		</div>
																		{getValue('app_v2_orderItem_takeAway')}
																	</div>
																</Checkbox>
															</div>
														)}

														{!readOnly && !(appParams?.items?.notesHidden === true) && (
															<div className='orderItemModifierGroup-modifier-root orderItem-modal-notes font-small'>
																<Divider className='my-4 bg-border' />
																<Textarea
																	aria-label='input'
																	type='text'
																	classNames={{
																		inputWrapper: 'bg-inputBackground text-inputText',
																		label: `${appParams?.styles?.fonts?.capitalize ? 'font-bold uppercase' : ''} group-data-[filled-within=true]:text-inputText text-inputText group-data-[filled-within=true]:text-[12px]`,
																	}}
																	name='itemNotes'
																	label={getValue('app_v2_orderItem_notes')}
																	value={itemNotes}
																	fullWidth={true}
																	onChange={handleChangeNotes}
																	onBlur={handleBlurNotes}
																/>
															</div>
														)}
														{!readOnly && upsaleItems != null && upsaleItems.length > 0 && (
															<>
																<div className='text-center mb-05 mt-2 font-bold'>{getValue('app_v2_upsellTitle')}</div>
																<div className='upsell-items-container'>
																	{upsaleItems.map((item, index) => (
																		<UpsaleItem key={index} itemUUID={item.itemUUID} />
																	))}
																</div>
															</>
														)}
													</div>
												</div>

												<div className='w-full shrink-0 flex flex-row pt-2 items-center justify-between pb-4 px-2 overflow-hidden gap-2 z-10'>
													{couponItem == null && menuItemParams?.hideCounter == null && !readOnly && (
														<div className='flex flex-row gap-2 w-auto items-center p-[0.3rem] bg-background border-1 border-primary rounded-full'>
															<Button color='primary' radius='full' variant='solid' isDisabled={assembledItem?.count < 2} isIconOnly onPress={() => changeCount(assembledItem?.count - 1)}>
																<Minus />
															</Button>
															<div className='min-w-[30px] flex items-center justify-center'>
																<NumberFlow value={+assembledItem?.count || 0} />
															</div>
															<Button radius='full' color='primary' variant='solid' isIconOnly onPress={() => changeCount(assembledItem?.count + 1)}>
																<Plus />
															</Button>
														</div>
													)}
													{couponItem == null && (
														<div className={` ${appParams?.buttons?.['addToBasket']?.containerClass || 'grow overflow-hidden'} `}>
															<AnimatePresence>
																<BarSoftButton onPress={handleAddToCart} forceHideStartIcon forceCustom={isAdded} color={isAdded ? 'success' : 'primary'} buttonName='addToBasket' fullWidth isDisabled={assembledItem?.valid ? false : true} size='lg' className=' px-3 justify-start'>
																	<AnimatePresence mode='wait'>
																		<motion.div key={isAdded ? 'check' : 'cart'} initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} exit={{opacity: 0, y: -20}} transition={{duration: 0.2}} className='flex items-center w-full gap-2'>
																			{isAdded ? (
																				<>
																					<motion.div
																						initial={{scale: 0}}
																						animate={{scale: 1}}
																						transition={{
																							type: 'spring',
																							stiffness: 500,
																							damping: 15,
																							delay: 0.1,
																						}}>
																						<Check className='w-5 h-5' />
																					</motion.div>
																					<span>{getValue('app_v2_item_added')}</span>
																				</>
																			) : (
																				<>
																					<motion.div
																						animate={{
																							rotate: [0, 10, -10, 0],
																						}}
																						transition={{
																							duration: 0.5,
																							ease: 'easeInOut',
																							times: [0, 0.2, 0.8, 1],
																							repeat: 0,
																							repeatDelay: 1,
																						}}>
																						<ShoppingCart className='w-5 h-5' />
																					</motion.div>
																					<div className={`w-full flex flex-row gap-2 items-center justify-between overflow-hidden`}>
																						<span className='font-semibold'>{buttonText}</span>
																						{menuItemParams == null && (
																							<span className='min-w-[30px] flex items-center justify-center'>
																								<NumberFlow value={+assembledItem?.totalPrice || 0} suffix=' Ft' />
																							</span>
																						)}
																					</div>
																				</>
																			)}
																		</motion.div>
																	</AnimatePresence>

																	{isAdded && <motion.div initial={{scale: 0, opacity: 1}} animate={{scale: 2, opacity: 0}} transition={{duration: 0.7}} className='absolute w-full h-full bg-white rounded-full' />}
																</BarSoftButton>
															</AnimatePresence>
														</div>
													)}
													{couponItem != null && (
														<div className={` ${appParams?.buttons?.['addToBasket']?.containerClass || ''} `}>
															<BarSoftButton buttonName='addToBasket' color='primary' onPress={() => handleItemSelect(assembledItem)}>
																{getValue('app_v2_items_coupon_item_select')}
															</BarSoftButton>
														</div>
													)}
												</div>
											</>
										)}
									</>
								)}
							</DrawerBody>
						</DrawerContent>
					</Drawer>
				</>
			) : (
				<BarSoftDrawer
					open={isOpen}
					onOpenChange={(open) => {
						setIsOpen(!isOpen)
						setTimeout(() => {
							setShowLoginDescModal(false)
							setMenuSelectIsOpen(false)
							setIsAdded(false)
						}, 400)
						if (typeof onCloseCustom === 'function') {
							onCloseCustom()
						}
					}}
					aria-describedby='desc'>
					<BarSoftDrawerTitle aria-describedby='desc'></BarSoftDrawerTitle>
					<BarSoftDrawerContent className='h-full flex flex-col gap-0  items-start justify-start  overflow-hidden w-full z-50' aria-describedby='desc'>
						{(showLoginDescModal || (!userLoggedIn && menuSelectIsOpen)) && (
							<div className='flex flex-col gap-2 items-center justify-center w-full p-2 pt-8 pb-10 '>
								<div className='w-16 h-16'>
									<Icon name='login' className='fill-current' />
								</div>
								<h1 className='font-bold text-lg'>{getValue('app_v2_orderItem_loginRequired')}</h1>
								<p className='w-full text-center opacity-70 text-sm'>{getValue('app_v2_orderItem_loginRequired_desc')}</p>
								<BarSoftButton
									color='primary'
									onPress={() => {
										setLoginModal(true)
										setShowLoginDescModal(false)
										setIsOpen(false)
										if (typeof setLoginModalOpened === 'function') {
											setLoginModalOpened(true)
										}
									}}>
									{getValue('app_v2_orderItem_login')}
								</BarSoftButton>
								<BarSoftButton
									color='secondary'
									onPress={() => {
										setShowLoginDescModal(false)
										if (typeof setLoginModalOpened === 'function') {
											setLoginModalOpened(false)
										}
									}}>
									{getValue('app_v2_orderItem_close')}
								</BarSoftButton>
							</div>
						)}
						{!showLoginDescModal && menuSelectIsOpen && userLoggedIn && assembledItem !== null && (
							<MenuSelectModal
								isOpen={menuSelectIsOpen}
								setIsOpen={setMenuSelectIsOpen}
								setShowMenuOptions={setShowMenuOptions}
								showMenuOptions={showMenuOptions}
								sizes={assembledItem?.sizes}
								setSelectedMenuSize={setSelectedMenuSize}
								selectedMenuSize={selectedMenuSize}
								closeItemModal={() => {
									setIsOpen(false)
								}}
								setSize={setSize}
								addItem={addItem}
								setNoMenuSelected={setNoMenuSelected}
								userSelectedMenuOption={userSelectedMenuOption}
								setUserSelectedMenuOption={setUserSelectedMenuOption}
							/>
						)}
						{!showLoginDescModal && assembledItem !== null && !menuSelectIsOpen && (
							<>
								{appParams?.items?.modalLayout === 'imageFocued' ? (
									<ImageFocusedLayout
										assembledItem={assembledItem}
										itemName={itemName}
										itemDescription={itemDescription}
										allergens={allergens}
										menuItemParams={menuItemParams}
										sizeUUID={sizeUUID}
										readOnly={readOnly}
										upsaleItems={upsaleItems}
										couponItem={couponItem}
										onCouponItemSelect={onCouponItemSelect}
										onCloseCustom={onCloseCustom}
										displayDescription={displayDescription}
										setItemNotes={setItemNotes}
										setModifierCount={setModifierCount}
										setTryedToAdd={setTryedToAdd}
										setTakeAway={setTakeAway}
										setSize={setSize}
										setCount={setCount}
										setNotes={setNotes}
										setAllergens={setAllergens}
										setUpsaleItems={setUpsaleItems}
										setShowMore={setShowMore}
										setIsAdded={setIsAdded}
										setShowMenuOptions={setShowMenuOptions}
										setMenuSelectIsOpen={setMenuSelectIsOpen}
										setSelectedMenuSize={setSelectedMenuSize}
										setUserSelectedMenuOption={setUserSelectedMenuOption}
										setNoMenuSelected={setNoMenuSelected}
										setIsOpen={setIsOpen}
										tryedToAdd={tryedToAdd}
										itemNotes={itemNotes}
										handleChangeNotes={handleChangeNotes}
										handleBlurNotes={handleBlurNotes}
										setShowLoginDescModal={setShowLoginDescModal}
										handleAddToCart={handleAddToCart}
										buttonText={buttonText}
										isAdded={isAdded}
										changeCount={changeCount}
										handleItemSelect={handleItemSelect}
									/>
								) : (
									<>
										<div className='  w-full  overflow-x-hidden  !relative overflow-y-auto pb-2'>
											{assembledItem.availability.available === 0 && <div className='py-2 font-bold text-warning font-small text-center mb-1'>{getValue('app_v2_orderItem_notAvailable')}</div>}
											{(appParams?.items?.showImage || appParams?.items?.showImage === undefined) && appParams?.assets?.defaultItemImg != null && (
												<div className='overflow-hidden rounded-b-general' id='scrollContainer'>
													<div className={`${appParams?.styles?.items?.containItemModalImage ? 'bg-white' : ''}`}>
														<OEAsset
															uuid={assembledItem.attributes.appImage}
															addContainerClass='w-[500px] max-w-full h-[300px] max-h-[300px] overflow-hidden'
															addClass={`w-full h-full overflow-hidden ${appParams?.styles?.items?.containItemModalImage ? 'img-contain object-contain' : 'object-cover'}`}
															size='l'
														/>
													</div>
												</div>
											)}
											<div className='z-50 sticky top-0 pt-4 bg-background'>
												<div className='px-4 pt-1 pb-0 flex flex-row gap-1 bg-background items-center !relative z-50'>
													<div
														id='desc'
														className={`font-bold text-xl  ${appParams?.styles?.fonts?.capitalize ? 'font-extrabold uppercase' : ''} `}
														style={{
															color: itemName?.fontColor || '',
														}}>
														{getName(assembledItem.name)}
													</div>
												</div>
											</div>
											<div
												className=''
												style={{
													color: itemDescription?.fontColor || '',
												}}>
												{displayDescription(getName(assembledItem.description))}
											</div>
											{menuItemParams == null && assembledItem?.depositPrice > 0 && (
												<div className='w-full text-left px-4 text-sm opacity-70 italic'>
													{getValue('app_v2_item_deposit')}
													{' ('}
													{assembledItem?.depositPrice}
													{' Ft)'}
												</div>
											)}
											<div className='w-full flex flex-wrap gap-2 flex-row px-2'>
												{allergens.map((alle, index) => (
													<div key={index} className='text-foreground'>
														<div className='w-6 h-6'>
															<Icon name={alle} className='fill-current' secondClassName={'fill-background'} />
														</div>
													</div>
												))}
											</div>
											<div className='px-2'>
												{allergens.length > 0 && (
													<span className=' text-sm'>
														<span className='pl-1'>{getValue('app_v2_allergens')}: </span>
														{allergens.map((alle, index) => (
															<span key={index} className='allergen'>
																{getValue('app_v2_allergens_' + alle)}
																{allergens.length !== index + 1 && ', '}
															</span>
														))}
													</span>
												)}
												<div className=' mt-1'>
													{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('meat') && (
														<div className='w-6 h-6'>
															<Icon name={'meat'} className='fill-current' secondClassName={'fill-background/0'} />
														</div>
													)}
													{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('lactoseFree') && (
														<div className='w-6 h-6'>
															<Icon name={'milk'} className='fill-current' secondClassName={'fill-background/0'} />
														</div>
													)}
													{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('vegan') && (
														<div className='w-6 h-6'>
															<Icon name={'vegan'} className='fill-current' secondClassName={'fill-background/0'} />
														</div>
													)}
													{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('glutenFree') && (
														<div className='w-6 h-6'>
															<Icon name={'glutenFree'} className='fill-current' secondClassName={'fill-background/0'} />
														</div>
													)}
												</div>
											</div>
											{menuItemParams == null && sizeUUID == null && assembledItem?.sizes?.filter((size) => !size?.attributes?.menuSize).length > 1 && (
												<div className=' z-10 px-2'>
													<SizeSelector sizes={assembledItem.sizes?.filter((size) => !size?.attributes?.menuSize)} setSize={setSize} selectedSizeUUID={assembledItem.selectedSizeUUID} />
												</div>
											)}
											<div className='px-2 flex flex-col gap-2 w-full z-0 !relative '>
												{assembledItem.modifierGroups
													?.filter((group) => group?.availability?.visible === 1)
													.sort((a, b) => (a?.min > b?.min ? 1 : -1))
													.sort((a, b) => (a?.idx > b?.idx ? 1 : -1))
													.map((group, index) => {
														return (
															<Element key={group.uuid} name={group.uuid}>
																<ModifierGroupSelector key={group.uuid} firstInvalid={null} group={group} setModifierCount={setModifierCount} readOnly={readOnly} tryedToAdd={tryedToAdd} name={group?.uuid} />
															</Element>
														)
													})}
												{!readOnly && !(appParams?.items?.takeAwayHidden === true) && (
													<div className='my-2 w-full'>
														<Checkbox isSelected={assembledItem.takeAway} onValueChange={() => setTakeAway(assembledItem.takeAway ? 0 : 1)}>
															<div className='flex flex-row gap-2 items-center'>
																<div className='w-6 h-6'>
																	<Icon name='takeAway' className='fill-current' />
																</div>
																{getValue('app_v2_orderItem_takeAway')}
															</div>
														</Checkbox>
													</div>
												)}

												{!readOnly && !(appParams?.items?.notesHidden === true) && (
													<div className='orderItemModifierGroup-modifier-root orderItem-modal-notes font-small'>
														<Divider className='my-4 bg-border' />
														<Textarea
															aria-label='input'
															type='text'
															classNames={{
																inputWrapper: 'bg-inputBackground text-inputText',
																label: `${appParams?.styles?.fonts?.capitalize ? 'font-bold uppercase' : ''} group-data-[filled-within=true]:text-inputText text-inputText group-data-[filled-within=true]:text-[12px]`,
															}}
															name='itemNotes'
															label={getValue('app_v2_orderItem_notes')}
															value={itemNotes}
															fullWidth={true}
															onChange={handleChangeNotes}
															onBlur={handleBlurNotes}
															onFocus={() => {
																console.log('focus')
															}}
														/>
													</div>
												)}
												{!readOnly && upsaleItems != null && upsaleItems.length > 0 && (
													<>
														<div className='text-center mb-05 mt-2 font-bold'>{getValue('app_v2_upsellTitle')}</div>
														<div className='upsell-items-container'>
															{upsaleItems.map((item, index) => (
																<UpsaleItem key={index} itemUUID={item.itemUUID} />
															))}
														</div>
													</>
												)}
											</div>
										</div>

										<div className='w-full shrink-0 flex flex-row pt-2 items-center justify-between pb-4 px-2 overflow-hidden gap-2 z-10'>
											{couponItem == null && menuItemParams?.hideCounter == null && !readOnly && (
												<div className='flex flex-row gap-2 w-auto items-center p-[0.3rem] bg-background border-1 border-primary rounded-full'>
													<Button color='primary' radius='full' variant='solid' isDisabled={assembledItem?.count < 2} isIconOnly onPress={() => changeCount(assembledItem?.count - 1)}>
														<Minus />
													</Button>
													<div className='min-w-[30px] flex items-center justify-center'>
														<NumberFlow value={+assembledItem?.count || 0} />
													</div>
													<Button radius='full' color='primary' variant='solid' isIconOnly onPress={() => changeCount(assembledItem?.count + 1)}>
														<Plus />
													</Button>
												</div>
											)}
											{couponItem == null && (
												<div className={` ${appParams?.buttons?.['addToBasket']?.containerClass || 'grow overflow-hidden'} `}>
													<AnimatePresence>
														<BarSoftButton onPress={handleAddToCart} forceHideStartIcon forceCustom={isAdded} color={isAdded ? 'success' : 'primary'} buttonName='addToBasket' fullWidth isDisabled={assembledItem?.valid ? false : true} size='lg' className=' px-3 justify-start'>
															<AnimatePresence mode='wait'>
																<motion.div key={isAdded ? 'check' : 'cart'} initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} exit={{opacity: 0, y: -20}} transition={{duration: 0.2}} className='flex items-center w-full gap-2'>
																	{isAdded ? (
																		<>
																			<motion.div
																				initial={{scale: 0}}
																				animate={{scale: 1}}
																				transition={{
																					type: 'spring',
																					stiffness: 500,
																					damping: 15,
																					delay: 0.1,
																				}}>
																				<Check className='w-5 h-5' />
																			</motion.div>
																			<span>{getValue('app_v2_item_added')}</span>
																		</>
																	) : (
																		<>
																			<motion.div
																				animate={{rotate: [0, 10, -10, 0]}}
																				transition={{
																					duration: 0.5,
																					ease: 'easeInOut',
																					times: [0, 0.2, 0.8, 1],
																					repeat: 0,
																					repeatDelay: 1,
																				}}>
																				<ShoppingCart className='w-5 h-5' />
																			</motion.div>
																			<div className={`w-full flex flex-row gap-2 items-center justify-between overflow-hidden`}>
																				<span className='font-semibold'>{buttonText}</span>
																				{menuItemParams == null && (
																					<span className='min-w-[30px] flex items-center justify-center'>
																						<NumberFlow value={+assembledItem?.totalPrice || 0} suffix=' Ft' />
																					</span>
																				)}
																			</div>
																		</>
																	)}
																</motion.div>
															</AnimatePresence>

															{isAdded && <motion.div initial={{scale: 0, opacity: 1}} animate={{scale: 2, opacity: 0}} transition={{duration: 0.7}} className='absolute w-full h-full bg-white rounded-full' />}
														</BarSoftButton>
													</AnimatePresence>
												</div>
											)}
											{couponItem != null && (
												<div className={` ${appParams?.buttons?.['addToBasket']?.containerClass || ''} `}>
													<BarSoftButton buttonName='addToBasket' color='primary' onPress={() => handleItemSelect(assembledItem)}>
														{getValue('app_v2_items_coupon_item_select')}
													</BarSoftButton>
												</div>
											)}
										</div>
									</>
								)}
							</>
						)}
					</BarSoftDrawerContent>
				</BarSoftDrawer>
			)}
		</>
	)
}

export default OrderItemModalV3
